module.exports = __webpack_public_path__ + "static/media/rambu proce.64eb1044.jpeg";